import { IconWorld, IconLock, IconPlus, IconX } from '@tabler/icons-react';
import { useChangeLobbyTypeMutation, useLeaveLobbyMutation } from '@http';
import { InvitePlayerModal } from '@components/lobby/InvitePlayerModal';
import { useLobbyStore, useAppStore } from '@stores';
import { Glitch } from '@components/helpers/Glitch';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

export function SmallLobby() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Lobby' });
  const { mutateAsync: changeTypeAsync } = useChangeLobbyTypeMutation();
  const { mutateAsync: leaveLobby } = useLeaveLobbyMutation();
  const { state } = useLobbyStore();
  const { setTab } = useAppStore();
  if (!state) return null;

  const hasOtherPlayers = state.players.length > 1;

  const changeType = () => {
    changeTypeAsync();

    const toastText = state.type === 'public'
      ? t('privateSuccess')
      : t('publicSuccess');
    toast(toastText, { type: 'success' });
  };

  const leave = () => {
    leaveLobby();
    setTab('navigation');
  };

  return (
    <div className="sidebar">
      <div className="flex-1">
        {state.players.map((player) => (
          <img src={`img/avatars/${player.avatar}.avif`} className="sidebar-button" key={player.id} />
        ))}

        {state.invites?.map((invite) => (
          <div className="sidebar-button" key={invite}>
            <img className="absolute inset-0 object-cover" src="/img/avatars/avatar1.avif" />
            <div className="absolute inset-0 flex items-center justify-center backdrop-blur z-10">
              <p className="text-2xl">?</p>
            </div>
          </div>
        ))}
      </div>

      <button className="sidebar-bottom lobby-type" onClick={() => changeType()}>
        {state.type === 'public' ? <IconWorld size={20} /> : <IconLock size={20} />}
      </button>

      <InvitePlayerModal className="lobby-add">
        <button className="sidebar-bottom">
          <Glitch disabled={hasOtherPlayers}><IconPlus size={20} /></Glitch>
        </button>
      </InvitePlayerModal>

      {hasOtherPlayers && (
        <button className="sidebar-bottom" onClick={() => leave()}>
          <IconX size={20} />
        </button>
      )}
    </div>
  );
}